import { useAssetDetailsContext } from "@/pages/asset-details/context/assetDetailsContext";
import Grid2 from "@mui/material/Grid2";
import type { EditableCallbackParams } from "ag-grid-community";

type Props = EditableCallbackParams;

export const AssetNameColumnColumn = ({ data }: Props) => {
	const {
		state: { assetSearchName },
	} = useAssetDetailsContext();
	if (data?.id === -1) {
		return (
			<Grid2
				container
				spacing={1}
				style={{ alignItems: "center", justifyContent: "center" }}
			>
				<Grid2 style={{ alignItems: "center", justifyContent: "center" }}>
					{assetSearchName}
				</Grid2>
			</Grid2>
		);
	} else if (data?.id !== -1) {
		return <div title={data?.FullPath}>{data?.AssetName}</div>;
	} else return <></>;
};
